import React from 'react'
import PropTypes from 'prop-types'
import {Text, Box, Flex, Card, Stack, CardBody, Radio} from '@chakra-ui/react'
import {CheckCircleIcon} from '@chakra-ui/icons'
import {useTranslation} from 'react-i18next'
import BankLogo from '../../BankLogo'

const BankAccountCard = ({
  accountName,
  accountNumber,
  providerName,
  isDisplay,
  isSelected,
  onSelect,
  value,
}) => {
  const {t} = useTranslation('connectPayoutAccount')
  const lastFourDigits = accountNumber.slice(-4)

  return (
    <Card
      variant="outline"
      size="sm"
      borderRadius="lg"
      cursor="pointer"
      borderWidth="1px"
      borderColor="mld.neutral.500"
      onClick={onSelect}
    >
      <CardBody px={5}>
        <Flex gap="xs" align="center">
          {!isDisplay && (
            <Radio value={value ?? accountNumber} isChecked={isSelected} />
          )}

          <Box width="50px" align="center">
            <BankLogo providerName={providerName} />
          </Box>
          <Stack spacing="xs" flex="1">
            <Text fontSize="16px" color="black">
              {accountName}
            </Text>
            <Text fontSize="sm" color="mld.neutral.700">
              {t('modal.selectPayoutAccount.accountNumber', {
                accountNumber: lastFourDigits,
              })}
            </Text>
          </Stack>

          <Flex
            px="xs"
            py="xxs"
            gap="xxs"
            borderRadius="md"
            bg="mld.success.100"
            align="center"
          >
            <CheckCircleIcon width="10px" color="mld.success.700" />
            <Text
              textStyle="body-detail"
              fontWeight="regular"
              lineHeight="125%"
            >
              {t('modal.selectPayoutAccount.connectedBadge')}
            </Text>
          </Flex>
        </Flex>
      </CardBody>
    </Card>
  )
}

BankAccountCard.propTypes = {
  accountName: PropTypes.string.isRequired,
  accountNumber: PropTypes.string.isRequired,
  providerName: PropTypes.string,
  isDisplay: PropTypes.bool,
  isSelected: PropTypes.bool,
  onSelect: PropTypes.func,
  value: PropTypes.string,
}

BankAccountCard.defaultProps = {
  isDisplay: false,
  isSelected: false,
  providerName: null,
  onSelect: null,
  value: undefined,
}

export default BankAccountCard
